import en from './en.json'
import fr from './fr.json'

export type LocaleCode = 'en' | 'fr'

type Messages = typeof en

const catalogs: Record<LocaleCode, Messages> = {
    en,
    // fr is available but structurally identical to en, so it is safe to widen to Messages
    fr: fr as Messages
}

// The shipped default locale is english. Admin is english-only today; french is
// provided in the catalog and can be enabled by changing this value.
let activeLocale: LocaleCode = 'en'

export function setLocale(locale: LocaleCode): void {
    activeLocale = locale
}

export function getLocale(): LocaleCode {
    return activeLocale
}

/* eslint-disable-next-line @typescript-eslint/no-explicit-any */
function resolveKey(catalog: any, key: string): string | undefined {
    const value = key.split('.').reduce((acc, part) => {
        if (acc === undefined || acc === null) return undefined
        return acc[part]
    }, catalog)
    return typeof value === 'string' ? value : undefined
}

function interpolate(template: string, params?: Record<string, string | number>): string {
    if (!params) return template
    return template.replace(/\{(\w+)\}/g, (match, name) => {
        const replacement = params[name]
        return replacement === undefined ? match : String(replacement)
    })
}

/**
 * Minimal typed translation helper. Looks up a dot-delimited key in the active
 * locale catalog (falling back to english), then interpolates `{name}` tokens.
 */
export function t(key: string, params?: Record<string, string | number>): string {
    const template = resolveKey(catalogs[activeLocale], key) ?? resolveKey(catalogs.en, key) ?? key
    return interpolate(template, params)
}
